<template>
  <div class="app-container min-h-screen flex">
    <nav
      class="flex fixed h-16 top-0 left-0 right-0 z-50 bg-white/70 dark:bg-gray-900 backdrop-blur-md border-b border-gray-200 dark:border-gray-800"
    >
      <img src="/img/settler-exchange-logo B logo only.png" class="p-2 mr-auto">
      <div class="flex h-full items-center justify-end px-4">
        <UButton
          class="mr-2"
          color="neutral"
          variant="subtle"
          :icon="colorModeIcon"
          title="Color Mode"
          @click="toggleColorMode"
        />

        <UDropdownMenu
          :items="items"
          :content="{
            align: 'end',
            side: 'bottom',
            sideOffset: 8,
          }"
        >
          <UButton
            :label="user ? user.user_metadata.name : 'Options'"
            icon="i-lucide-menu"
            color="neutral"
            variant="outline"
          />
        </UDropdownMenu>

        <!-- <NuxtLink v-if="user" to="/profile" class="flex items-center gap-2"
          >Profile</NuxtLink
        > -->
        <!-- <slot name="center" />
        <slot name="right" /> -->
      </div>
    </nav>
    <div class="flex-1 pt-16 w-full sm:w-auto dark:bg-gray-900">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
//import type { DropdownMenuItem } from "@nuxt/ui";

const user = useSupabaseUser();
const supabase = useSupabaseClient();

const items = computed(() => [
  {
    label: "Profile",
    icon: "i-lucide-user",
    to: "/profile",
    class: user.value ? "" : "hidden",
  },
  {
    label: "New game",
    icon: "i-lucide-plus",
    to: "/game/setup",
  },
  {
    label: "Sign out",
    icon: "i-lucide-log-out",
    onClick: () => {
      supabase.auth.signOut();
      navigateTo("/login");
    },
    class: user.value ? "" : "hidden",
  },
  {
    label: "Sign in",
    icon: "i-lucide-log-in",
    to: "/login",
    class: user.value ? "hidden" : "",
  },
]);

//color mode
const { colorModeIcon, toggleColorMode } = useUseColorModeSettings();
</script>
